import { useState, useCallback } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import api from 'client';

export default () => {
  const queryClient = useQueryClient();
  const [appointmentId, setAppointmentId] = useState(null);
  const [accessCode, setAccessCode] = useState(null);
  const getVideoSessionTokens = useCallback(
    ({ appointmentId: appointmentIdVal, accessCode: accessCodeVal }) =>
      api
        .post('/apis/v2/direct_video_session_tokens', { appointmentId: appointmentIdVal, accessCode: accessCodeVal })
        .then((data) => ({ adracareSessionToken: data?.data?.data?.id, ...data?.data?.data?.attributes }))
        .then((data) => {
          queryClient.setQueryData(['POST', '/apis/v2/direct_video_session_tokens', { appointmentId, accessCode }], data);
          setAppointmentId(appointmentIdVal);
          setAccessCode(accessCodeVal);
        }),
    [],
  );

  const { data } = useQuery(['POST', '/apis/v2/direct_video_session_tokens', { appointmentId, accessCode }], {
    enabled: !!appointmentId && !!accessCode,
    select: (responseData) => ({ adracareSessionToken: responseData?.data?.id, ...responseData?.data?.attributes }),
  });

  const participants = Object.values(data?.participants || {});
  return {
    videoSessionTokens: data,
    participants: participants || [],
    wherebyUrl: data?.wherebyUrl,
    getVideoSessionTokens,
  };
};
